import { ActivitiesRow } from "@outschool/db-queries";

import { hasTeacherSchedule } from "../server/lib/Activity";
import { isOneOnOne } from "./Activity";
import { refund_policy } from "./generated/database";

export interface RefundPolicyType {
  deprecated?: boolean;
  name: string;
  description: string;
}

export function getRefundPolicy(
  refundPolicyType: refund_policy,
  activity: ActivitiesRow
) {
  if (activity.is_club) {
    return GroupsRefundPolicy;
  } else if (hasTeacherSchedule(activity) && isOneOnOne(activity)) {
    return OneOnOneRefundPolicies[refundPolicyType];
  } else {
    return RefundPolicies[refundPolicyType];
  }
}

/**
 * We override the language for Groups, but keep the type as 'limited'
 */
export const GroupsRefundPolicy: RefundPolicyType = {
  name: "Groups",
  description:
    "Families receive a full refund if they withdraw from a Group within 24 hours of purchase. They may also receive a refund (for the current monthly term) within 24 hours of subscription renewal on the first of the month."
};

export const OneOnOneRefundPolicies: Record<"limited", RefundPolicyType> = {
  limited: {
    name: "1-on-1 Standard",
    description:
      "Full refund until 48 hours before class, or within 24 hours of initial purchase (until class starts)."
  }
};

export const RefundPolicies: Record<refund_policy, RefundPolicyType> = {
  variable: {
    deprecated: true,
    name: "Variable",
    description:
      "Full refund up to a week in advance, or within 24 hours of purchase (until class starts), then at the teacher’s discretion"
  },
  limited: {
    name: "Limited",
    description:
      "Full refund until a week in advance, or within 24 hours of purchase (until class starts)."
  },
  moderate: {
    name: "Moderate",
    description:
      "Full refund until a week in advance, or within 24 hours of purchase (until class starts), then a 75% refund within the first week."
  },
  flexible: {
    name: "Flexible",
    description:
      "Full refund until the class begins, or within 24 hours of purchase (until class starts), then a pro-rated refund based on the number of meetings."
  }
};

const types = {
  VARIABLE: refund_policy.variable,
  LIMITED: refund_policy.limited,
  MODERATE: refund_policy.moderate,
  FLEXIBLE: refund_policy.flexible
};

export const REFUND_POLICY_TYPES = Object.freeze(types);
